import React, { useCallback, useEffect, useRef, useState } from "react";
import { CustomBreadcrumb } from "../../../shared/components/custom-breadcrumb/custom-breadcrumb";
import { CustomTable } from "../../../shared/components/custom-table/custom-table";
import { SERVICES } from "../../../core/services/services";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { CustomModal } from "../../../shared/components/custom-modal/custom-modal";
import { Toast } from "primereact/toast";
import { HELPER } from "../../../shared/helper/helper";
import { AccessDenied } from "../../access-denied/access-denied";
import ErrorBoundary from "../../../shared/components/error-boundary/error-boundary";
import { Optional } from "../../../shared/components/optional/optional";
import { BACKOFFICE_API } from "../../../core/apis/backoffice-apis";
import { VerificationLimitUpdateForm } from "./verification-limit-update-form";
import { CustomToast } from "../../../shared/components/alert/custom-toast";

export function VerificationLimits() {
  const toast = useRef(null);
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [error, setError] = useState("");
  const [search, setSearch] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [range] = useState(5);
  const [emptyText, setEmptyText] = useState("");
  const [currentModalIndex, setCurrentModalIndex] = useState(0);
  const [pageNo, setPageNo] = useState(0);
  const [selectedVerificationLimit, setSelectedVerificationLimit] =
    useState(null);
  const [
    verificationLimitsValidityResponse,
    setVerificationLimitsValidityResponse,
  ] = useState(null);

  const tableHeaders = [
    { label: "Name", value: "name" },
    { label: "Minimum Amount", value: "minimumAmount" },
    { label: "Max Amount", value: "maxAmount" },
    { label: "Status", value: "status" },
    // {
    //   label: "Allowed Verification Channels",
    //   value: "allowedVerificationChannels",
    // },
    { label: "Actions", value: "actions" },
  ];
  const [verificationLimits, setVerificationLimits] = useState([]);
  const [authorities] = useState([
    { label: "UPDATE", value: "bo_dd_update_verification_limits" },
  ]);

  // useEffect(() => {
  //   if (verificationLimitsValidityResponse) {
  //     console.log("Validity-response", verificationLimitsValidityResponse);
  //     toast?.current?.show({
  //       severity: "warn",
  //       summary: "Warning!",
  //       detail: verificationLimitsValidityResponse,
  //       life: 60000,
  //     });
  //   }
  // }, [verificationLimitsValidityResponse]);

  const getVerificationLimitsValidity = useCallback(() => {
    const url = "/backoffice/verification-limit/validate";
    SERVICES.MAKE_GET_REQUEST(url)
      .then((data) => {
        const response = data?.result;
        setVerificationLimitsValidityResponse(response);
        if (error) {
          setVerificationLimitsValidityResponse(null);
        }
      })
      .catch((error) => {
        setVerificationLimitsValidityResponse(HELPER.PROCESS_ERROR(error));
      });
  }, [error]);

  useEffect(() => {
    getVerificationLimitsValidity();
  }, [getVerificationLimitsValidity]);

  const openAction = useCallback((e, action) => {
    // eslint-disable-next-line default-case
    switch (action) {
      case "UPDATE": {
        setSelectedVerificationLimit(e);
        setCurrentModalIndex(0);
        setVisible(true);
        // getTransactionDetails(e, isMobile);
        break;
      }
    }
  }, []);

  const handleSuccess = useCallback(
    (data, isSearch = false) => {
      const result = data.result.content;
      if (!result.length) {
        setEmptyText("No verificationLimits found...");
        if (isSearch) {
          setSearch(true);
        }
      } else {
        let arr = [];
        setTotalItems(data.result.totalItems);
        setTotalPages(data.result.totalPages);
        result.forEach((e) => {
          arr.push({
            ...e,
            status: e?.isActive ? "Active" : "Inactive",
            actions: "UPDATE",
            detailsFunction: openAction,
          });
        });
        setVerificationLimits(arr);
      }
      setCurrentIndex(1);
      setError(null);
    },
    [openAction]
  );

  const getVerificationLimits = useCallback(() => {
    setCurrentIndex(0);
    setVerificationLimits([]);
    let params = {
      page: pageNo,
      size: 10,
    };
    params = HELPER.TO_URL_STRING(params);
    SERVICES.MAKE_GET_REQUEST(BACKOFFICE_API.VERIFICATION_LIMITS, params)
      .then((data) => {
        handleSuccess(data, false);
      })
      .catch((error) => {
        setVerificationLimitsValidityResponse(null);
        setError(HELPER.PROCESS_ERROR(error));
        setCurrentIndex(1);
      });
  }, [pageNo, handleSuccess]);

  useEffect(() => {
    getVerificationLimits();
  }, [getVerificationLimits]);

  function goToPage(pageNo) {
    setPageNo(pageNo);
  }

  function onHide() {}

  function openModal(index, isMobile) {
    setCurrentModalIndex(index);
    if (isMobile) {
      setCurrentIndex(2);
    } else {
      setVisible(true);
    }
  }

  function reload() {
    setPageNo(0);
    setSearch(false);
    setCurrentIndex(0);
    getVerificationLimits();
  }

  function closeModal(refresh) {
    if (refresh === true) {
      getVerificationLimits();
      getVerificationLimitsValidity();
    }
    if (visible) {
      setVisible(false);
    }
    if (currentIndex === 2) {
      setCurrentIndex(1);
    }
  }

  function mobileFilter() {
    openModal(1, true);
  }

  const mobileModal = () => {
    // eslint-disable-next-line default-case
    switch (currentModalIndex) {
      case 0:
        return (
          <VerificationLimitUpdateForm
            closeModal={closeModal}
            verificationLimit={selectedVerificationLimit}
          />
        );
    }
  };

  const modalContent = () => {
    // eslint-disable-next-line default-case
    switch (currentModalIndex) {
      case 0:
        return (
          <VerificationLimitUpdateForm
            closeModal={closeModal}
            verificationLimit={selectedVerificationLimit}
          />
        );
    }
  };

  const verificationLimitsView = () => {
    // eslint-disable-next-line default-case
    switch (currentIndex) {
      case 0:
        return (
          <div className="loading-container">
            <CustomLoader loadingText="Loading authentication limits..." />
          </div>
        );
      case 1:
        return (
          <CustomTable
            authorities={authorities}
            tableActionFunction={mobileFilter}
            isReload={true}
            totalPages={totalPages}
            totalItems={totalItems}
            currentPage={pageNo + 1}
            range={range}
            emptyText={emptyText}
            search={search}
            reload={reload}
            error={error}
            items={verificationLimits}
            headers={tableHeaders}
            nextPage={() => setPageNo(pageNo + 1)}
            prevPage={() => setPageNo(pageNo - 1)}
            goToFirstPage={() => setPageNo(0)}
            goToLastPage={() => setPageNo(totalPages - 1)}
            goToPage={goToPage}
          />
        );
      case 2:
        return (
          <div className="mobile-modal-container">
            <div className="custom-card">
              <div className="mobile-card-position">{mobileModal()}</div>
            </div>
          </div>
        );
    }
  };

  return (
    <ErrorBoundary>
      <div>
        <Toast ref={toast} />
        <div>
          <CustomModal
            closeModal={closeModal}
            onHide={onHide}
            visible={visible}
            modalContent={modalContent}
          />
        </div>
        <div className="page-title p-text-left">Authentication Limits</div>
        <div className="p-mt-2">
          <CustomBreadcrumb page="Manage Authentication Limits" />
        </div>
        <Optional show={verificationLimitsValidityResponse && !error}>
          <div className="auth-limit-warning p-mt-5">
            <CustomToast
              title={"Warning!"}
              description={verificationLimitsValidityResponse}
              type="warning"
            />
          </div>
        </Optional>

        <Optional show={HELPER.HAS_AUTHORITY("bo_dd_view_verification_limits")}>
          <div className="p-mt-5">{verificationLimitsView()}</div>
        </Optional>
        <Optional
          show={!HELPER.HAS_AUTHORITY("bo_dd_view_verification_limits")}
        >
          <AccessDenied />
        </Optional>
      </div>
    </ErrorBoundary>
  );
}
